<template>
  <div id="contenedor-calendario-licitaciones">
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="110">
          <v-toolbar
            flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setHoy">
              Hoy
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="anterior">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-toolbar-title
            v-if="$refs.calendar"
            class="text-uppercase">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="siguiente">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-menu
              bottom
              right>
              <template v-slot:activator="{ on, attrs }">
                <!-- <custom-button
                  :label="typeToLabel[type]"
                  iconText="mdi-menu-down"
                  tipo="agregar"
                  v-bind="attrs"
                  v-on="on">
                </custom-button> -->
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Día</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mes</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <!-- Nomenclatura de eventos de licitación -->
          <v-row justify="center">
            <v-chip
            class="mx-1"
            color="#1E88E5"
            outlined
            dark>
              <h3>Visita de Obra</h3>
            </v-chip>
            <v-chip
            class="mx-1"
            color="#673AB7"
            outlined
            dark>
              <h3>Junta de Aclaraciones</h3>
            </v-chip>
            <v-chip
            class="mx-1"
            color="#43BC82"
            outlined
            dark>
              <h3>Apertura de Propuestas</h3>
            </v-chip>
            <v-chip
            class="mx-1"
            color="#FA8B00"
            outlined
            dark>
              <h3>Fallo</h3>
            </v-chip>
          </v-row>
        </v-sheet>
        <v-sheet height="900">
          <v-skeleton-loader
            v-if="cargando"
            type="image"
            class="mt-4">
          </v-skeleton-loader>
          <v-calendar
            v-else
            ref="calendar"
            v-model="focus"
            color="grey lighten-2"
            :events="eventos"
            :event-color="getEventColor"
            :type="type"
            @click:event="mostrarEvento"
            @click:more="verDia"
            @click:date="verDia">
          </v-calendar>
          <v-alert
            v-if="!cargando && !eventos.length"
            outlined
            type="info"
            class="mt-4 mb-0">
            No hay eventos registrados para mostrar en el calendario.
          </v-alert>
          <!-- Menu de evento -->
          <v-menu
            v-model="abrirSeleccionado"
            :close-on-content-click="false"
            :activator="elementoSeleccionado"
            offset-x
            min-width="350px"
            max-width="350px">
            <!-- card de informacion del evento -->
            <v-card
              color="grey lighten-4"
              min-width="350px"
              max-width="350px"
              flat>
              <v-toolbar
                :color="getEventColor(eventoSeleccionado)"
                dark>
                <v-toolbar-title v-html="eventoSeleccionado.name"></v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <h3>Evento: {{ eventoSeleccionado.evento }}</h3>
                </v-row>
                <v-row>
                  <h3>Fecha: {{ new Date(eventoSeleccionado.start).toLocaleDateString()}}</h3>
                </v-row>
                <v-row>
                  <h3>Hora: {{ horaFormatoHrs(eventoSeleccionado.start)}}</h3>
                </v-row>
                <v-spacer></v-spacer>
                <v-row>
                  <h3>Lugar: {{eventoSeleccionado.lugar}}</h3>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                  @click="abrirSeleccionado = false"
                  tipo="formCancelar"
                  label="Cerrar"
                  class="mr-3"
                >
                </custom-button>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CalendarioLicitaciones',
  props: {
    eventosLicitaciones: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomButton,
  },
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
    },
    eventoSeleccionado: {},
    elementoSeleccionado: null,
    abrirSeleccionado: false,
    eventos: [],
  }),
  mounted() {
    this.$refs.calendar.checkChange();
  },
  watch: {
    eventosLicitaciones: {
      immediate: true,
      handler() {
        this.setEventos();
      },
    },
  },
  methods: {
    verDia({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      if (event.color === 1) return '#1E88E5';
      if (event.color === 2) return '#673AB7';
      if (event.color === 3) return '#43BC82';
      return '#FA8B00';
    },
    setHoy() {
      this.focus = '';
    },
    anterior() {
      this.$refs.calendar.prev();
    },
    siguiente() {
      this.$refs.calendar.next();
    },
    mostrarEvento({ nativeEvent, event }) {
      const open = () => {
        this.eventoSeleccionado = event;
        this.elementoSeleccionado = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.abrirSeleccionado = true;
        }));
      };

      if (this.abrirSeleccionado) {
        this.abrirSeleccionado = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    // Crear eventos de Calendario
    setEventos() {
      const eventos = [];
      if (this.eventosLicitaciones.length === 0) return;
      this.eventosLicitaciones.forEach((evento) => {
        // Ajustar la fecha para que Vuetify muestre UTC como si fuera hora local
        const utcDate = new Date(evento.fechaHora);
        const offset = utcDate.getTimezoneOffset() * 60000;
        const displayDate = new Date(utcDate.getTime() + offset);
        eventos.push({
          name: `${evento.licitacion.numero}`,
          evento: evento.eventoTexto,
          start: displayDate,
          end: displayDate,
          color: evento.evento,
          timed: true,
          lugar: evento.lugar,
        });
      });
      this.eventos = eventos;
    },
    horaFormatoHrs(fechaHora) {
      const fecha = new Date(fechaHora);
      const horas = fecha.getUTCHours().toString().length === 1 ? `0${fecha.getUTCHours()}` : fecha.getUTCHours();
      const minutos = fecha.getUTCMinutes().toString().length === 1 ? `0${fecha.getUTCMinutes()}` : fecha.getUTCMinutes();
      return `${horas}:${minutos}`;
    },
  },
};
</script>

<style>

</style>
